import { render, staticRenderFns } from "./player-list-page.vue?vue&type=template&id=1986e879&scoped=true&"
import script from "./player-list-page.vue?vue&type=script&lang=js&"
export * from "./player-list-page.vue?vue&type=script&lang=js&"
import style0 from "./player-list-page.vue?vue&type=style&index=0&id=1986e879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986e879",
  null
  
)

export default component.exports